import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
// TODO: usar como estratégia de paginação
// import { offsetLimitPagination } from '@apollo/client/utilities';

import { getUserToken, getLoggedUser } from 'utils';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API_URL ?? '',
});

const autheticatedLink = setContext((_, { headers: defaultHeaders }) => {
  const user = getLoggedUser();
  const token = getUserToken();

  if (!user) {
    return {};
  }

  if (!token) {
    return {};
  }

  if (!user?.role) {
    return {};
  }

  const headers = {
    ...defaultHeaders,
    authentication: `Bearer ${token}`,
    'x-role': user.role,
  };

  return {
    headers,
  };
});

// TODO: adicionar response e networkError nos parâmetros abaixo: ({ graphQLErrors, networkError, `response` })
const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    // TODO: implementar lógica de erros junto ao backend
  }
});

export const apolloClient = new ApolloClient({
  link: from([errorLink, autheticatedLink, httpLink]),
  cache: new InMemoryCache({
    resultCaching: true,
    addTypename: false,
  }),
  connectToDevTools: process.env.REACT_APP_NODE_ENV !== 'production',
});
